export default "__VITE_ASSET__DKEbxwVI__"